import { Divider, styled } from '@mui/material';

export const AuthDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(0, -4),
}));
